//Hack: This is a hack to know single video widget is showing what video[moment/trailer/full webinar/ad]
//This data should come from amplily-app rather than the file name
import { VideoType } from "@/models/VideoType"

export default function getVideoType(fileName: string): VideoType | undefined {
  if (fileName.length < 16 && fileName.indexOf("m") == 0)
    return VideoType.Moment
  if (fileName.length > 16) {
    if (fileName.indexOf("ad") == 0) return VideoType.Ad
    if (fileName.indexOf("t") == 0) return VideoType.Trailer
    if (fileName.indexOf("v") == 0) return VideoType.Webinar
  }
  return undefined
}
